<template>
  <div id="train">
      <div class="page-header header-filter" data-parallax="true" style="background-image: url('assets/img/bg3.jpg')">
            <div class="container">
                <div class="row">
                <div class="col-md-8 ml-auto mr-auto">
                    <div class="brand text-center">
                    <h1 class="title">train Your title here</h1>
                    <h3 class="title description">Subtitle</h3>
                    </div>
                </div>
                </div>
            </div>
        </div>
        <div class="main main-raised">
            <div class="container">
                <div class="section text-center">
                <h2 class="title">Your main section here</h2>
                </div>
            </div>
        </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "train",
  props: [],
  data() {
    return {
      
    };
  },
  methods: {},
  filters: {},
  computed: {},
  created() {},
  mounted() {
  },
  components: {},
  watch: {}
};
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/pages/service/train.vue